/**
 * Truecaller mobile website helpers (Android only).
 * Uses deep link + backend polling as per Truecaller docs.
 */

const PARTNER_KEY = import.meta.env.VITE_TRUECALLER_PARTNER_KEY ?? "";
const PARTNER_NAME = import.meta.env.VITE_TRUECALLER_PARTNER_NAME ?? "StarClinch";

/** Returns true when running on an Android device (mobile web or WebView). */
export function canUseTruecaller(): boolean {
  if (typeof navigator === "undefined") return false;
  return /Android/i.test(navigator.userAgent || "");
}

/** Generate requestNonce / requestId (8–64 chars) for Truecaller flow. */
export function generateTruecallerRequestNonce(): string {
  const globalCrypto = (typeof crypto !== "undefined" ? crypto : undefined) as
    | Crypto
    | undefined;
  const uuid =
    globalCrypto?.randomUUID?.() ??
    `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
  return uuid.replace(/-/g, "").slice(0, 64);
}

/** Build Truecaller deep link URL for the given nonce. */
export function buildTruecallerDeepLink(requestNonce: string): string | null {
  if (!PARTNER_KEY || !PARTNER_NAME) {
    return null;
  }

  const params = new URLSearchParams({
    type: "btmsheet",
    requestNonce,
    partnerKey: PARTNER_KEY,
    partnerName: PARTNER_NAME,
    lang: "en",
    loginPrefix: "getstarted",
    loginSuffix: "signup",
    ctaPrefix: "continuewith",
    btnShape: "rect",
    skipOption: "useanothermethod",
  });

  return `truecallersdk://truesdk/web_verify?${params.toString()}`;
}

